export default __webpack_public_path__ + "static/SMM_Peakwork_Pressemeldung_1_1_de-b6d56b2348ea42239df20c4524fc539a.png";